module.exports = __webpack_public_path__ + "assets/images/dfb97f75e863e7cacab2296b527603cb.png";